import { render, staticRenderFns } from "./ChartAffiliation.vue?vue&type=template&id=193e889c&scoped=true"
import script from "./ChartAffiliation.vue?vue&type=script&lang=js"
export * from "./ChartAffiliation.vue?vue&type=script&lang=js"
import style0 from "./ChartAffiliation.vue?vue&type=style&index=0&id=193e889c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e889c",
  null
  
)

export default component.exports